/* unplugin-vue-components disabled */import { render } from "./PrintTicketsReceipts.vue?vue&type=template&id=5ecc289c&scoped=true&ts=true"
import script from "./PrintTicketsReceipts.vue?vue&type=script&lang=ts"
export * from "./PrintTicketsReceipts.vue?vue&type=script&lang=ts"

import "./PrintTicketsReceipts.vue?vue&type=style&index=0&id=5ecc289c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecc289c"]])

export default __exports__